import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import React, {useState, useEffect} from 'react';
import Chip from '@material-ui/core/Chip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHashtag } from '@fortawesome/free-solid-svg-icons';
import { faAws } from '@fortawesome/free-brands-svg-icons';
import { faJs } from '@fortawesome/free-brands-svg-icons';
import { faPython } from '@fortawesome/free-brands-svg-icons';

const projectsJa = [
	{
		chips: [ 'AWS', 'CloudTrail', 'Splunk', 'SQS', 'SES' ],
		title: 'AWS使用ログの解析とビジュアライズ化',
		area: '東京',
		detail: ['全体としては50人以上関わっているような大規模なプロジェクトだった。うまくいかないことが多少あり難しかったので、似た経験をもつ上司にたくさんのアドバイスを頂いた。', '任されたクライアント向け資料作り以外に、独自に設計図を作成するなどコミュニケーションの円滑さを大切にし、最終的には問題なく業務を遂げることができた。'],
		img: faAws,
		date: '2019年8月 - 現在',
		color: 'aws',
		vc: '',
		test: '',
		team: '4',
		phase: '要件定義 ~ 運用テスト'
	},
	{
		chips: [ 'AWS', 'Amazon Connect', 'Lambda'],
		title: 'コンタクトセンターの自動応答',
		area: '東京',
		detail: ['初めてAWSのプロジェクトを1人で担当した。', '電話の自動応答とユーザーの感情表示を1人で問題なく開発することができた。'],
		img: faAws,
		date: '2019年8月 - 現在',
		color: 'aws',
		vc: '',
		test: '',
		team: '1',
		phase: '要件定義 ~ 運用テスト'
	},
	{
		chips: [ 'AWS', 'Redshift', 'DirectConnect', 'QuickSight', 'Tableau+' ],
		title: 'データ活用環境POC構築',
		area: '名古屋',
		detail: ['クライアントからデータの「ビジュアライズ化」をしたいとの案件があり、PoC開発。', 'クライアントと上司の会議の結果、既存のデータをQuickSightに決定したが、社内ではTableau+なども検証した。', '開発後、どのようにクライアント自身で開発できるのかをレクチャした。'],
		img: faAws,
		date: '2019年5月 - 2019年8月',
		color: 'aws',
		vc: '',
		test: '',
		team: '3',
		phase: '要件定義 ~ 単体テスト'
	},
	{
		chips: [ 'C#', 'Javascript', 'ASP.NET' ],
		title: '薬局のWeb薬歴システム開発',
		area: '東京',
		detail: ['既存システムのWeb化の運用。', '結合テストで細かな部分で問題が見つかり、退職してしまった同僚が担当していた箇所もあり、問題箇所を探して修正するのに苦労した。', '『みんながわかりやすいコードを書く大切さ』を改めて学んだ。'],
		img: faJs,
		date: '2017年6月 - 2018年6月',
		color: 'js',
		vc: 'Git',
		test: '',
		team: '3',
		phase: '要件定義 ~ 運用テスト'
	},
	{
		chips: [ 'Python', 'AWS', 'Django', 'SQLite' ],
		title: '社内FAQシステム開発',
		area: '東京',
		detail: ['新入社員のための電子カルテの詳細説明や開発に関する疑問点などのFAQシステム。', '仲の良い同僚と自然言語処理を勉強していたので、上司に集まってもらい、自分たちで考えたプロジェクトを披露した。','意見交換など経て、他部署の部長などの指摘を頂きながら、正式に会社のプロジェクトと認められ、初めてチームリーダーとしてプロジェクトの最初から最後まで携わることができた。', '上司に時間を作って頂いて発表するときはとても緊張したが、何度も発表の練習もし想定の質問応答も考え準備した。', '初めてポジションとしてはチームリーダーを担ったが、これまでも仕事に責任はあると思っていたので、変わらず仕事に取り組んだ。'],
		img: faPython,
		date: '2017年1月 - 2017年5月',
		color: 'python',
		vc: 'Git',
		test: '',
		team: '2',
		phase: '要件定義 ~ 運用テスト'
	},
	{
		chips: [ 'C#', 'XML', '.NET' ],
		title: '総務省のクラウド型EHR高度化事業関連業務',
		area: '東京',
		detail: ['RFIDで認証し、.NETからWeb上のカルテデータを表示するシステム、DBテーブルの改修作業。初めて大型プロジェクトに参画。', '先輩がよく説明してくれたおかげで全体像も難なく把握でき、革新的なサービスの開発に携わることができた。'],
		img: faHashtag,
		date: '2017年1月 - 2017年5月',
		color: 'cSharp',
		vc: 'TFS',
		test: 'Microsoft Test Manager',
		team: '15',
		phase: '開発・単体テスト'
	},
	{
		chips: [ 'C#', 'XML', '.NET' ],
		title: '病院内の待ち番号システム開発',
		area: '東京',
		detail: ['発券されるごとに、番号を1ずつ増やし翌日になると番号がリセットされるシステム。', '初めて1人でプロジェクトを任され、不安だったが、不明点はネットで調べると解決し問題なく開発できた。'],
		img: faHashtag,
		date: '2016年9月 - 2016年10月',
		color: 'cSharp',
		vc: 'TFS',
		test: 'Microsoft Test Manager',
		team: '1',
		phase: '詳細設計, 開発・単体テスト'
	},
	{
		chips: [ 'C#', 'Visual Basic', 'MS SQL Server', '.NET' ],
		title: '電子カルテシステム開発(自社開発)',
		area: '東京',
		detail: ['薬剤システムのマスタの新機能開発、既存薬剤システムマスタのVBからC#への書き換え作業。', '先輩に不明点を教わりながら、既存コードを見て実践的にコードの書き方を学んだ。', '調べてもわからない不明点は勇気を出して誰かに聞いてしまったほうが早いことを学んだ。'],
		img: faHashtag,
		date: '2016年 - 2017年',
		color: 'cSharp',
		vc: 'TFS',
		test: 'Microsoft Test Manager',
		team: '6',
		phase: '開発・単体テスト'
	},
	{
		chips: [ 'C#', 'Java', 'Apache' ],
		title: '自然言語処理のためのAPI構築（研修）',
		area: '東京',
		detail: ['Javaで書いたBOW分析のAPIをSwaggerからJSON形式で.Netで表示(Apacheでwebサーバーの立ち上げ、運用)。', '初めてサーバを立ち上げたりMecabをインストールするなど、当時としては、とても難しかったがワクワクしながら楽しく取り組んだ。', '『可能な限り計算量の少ないコードを書くこと』と『細かいことを理解して仕組みを理解する大切さ』を学んだ。'],
		img: faHashtag,
		date: '2016年7月 - 2016年8月',
		color: 'cSharp',
		vc: '',
		test: '',
		team: '1',
		phase: '要件定義 ~ 運用テスト'
	}
];

const projectsEn = [
	{
		chips: [ 'AWS', 'CloudTrail', 'Splunk', 'SQS', 'SES' ],
		title: 'Analysis and visualization of AWS usage logs',
		area: 'Tokyo',
		detail: ["Overall, this large project involved over 50 people. It was a little difficult to figure out at first, so I got a lot of advice from my collegue that had experience with Splunk.', 'In addition to creating the required documentation for the clients, I also created original design docs that helped with overall communication and allowed the work to be completed without problems."],
		img: faAws,
		date: '2019 Aug - Present',
		color: 'aws',
		vc: '',
		test: '',
		team: '4',
		phase: 'All phases'
	},
	{
		chips: [ 'AWS', 'Amazon Connect', 'Lambda'],
		title: 'Contact center auto attendant',
		area: 'Tokyo',
		detail: ["The first AWS project that I was tasked to do by myself. I developed an automatic phone response system that also detected the user's emotion."],
		img: faAws,
		date: '2019 Aug - Present',
		color: 'aws',
		vc: '',
		test: '',
		team: '1',
		phase: 'All phases'
	},
	{
		chips: [ 'AWS', 'Redshift', 'DirectConnect', 'QuickSight', 'Tableau+' ],
		title: 'Data utilization environment POC construction',
		area: 'Nagoya',
		detail: ['The client wanted to visualize the data and develop a PoC.', 'We imported their data into AWS QuickSight and also set up Tableau.', 'After development, I gave a lecture on how to develop by themselves.'],
		img: faAws,
		date: '2019 May - 2019 Aug',
		color: 'aws',
		vc: '',
		test: '',
		team: '3',
		phase: 'All phases'
	},
	{
		chips: [ 'C#', 'Javascript', 'ASP.NET' ],
		title: 'Web pharmacy history system development',
		area: 'Tokyo',
		detail: ['Web-based operation of existing systems. We found a problem in the integration test, and the problem came from a part that a retired collegue was in charge with, so I had a hard time finding and fixing the problem.', 'I was reminded about the importance of writing easy-to-understand code.'],
		img: faJs,
		date: '2017 June - 2018 June',
		color: 'js',
		vc: 'Git',
		test: '',
		team: '3',
		phase: 'All phases'
	},
	{
		chips: [ 'Python', 'AWS', 'Django', 'SQLite' ],
		title: 'In-house FAQ system development',
		area: 'Tokyo',
		detail: ['FAQ system for new employees that shows detailed explanation of the development of the electronic medical record system.', 'Since I was studying natural language processing with my colleague, I asked my boss about presenting the project that we had considered. After exchanging ideas, it was officially recognized as a project of the company while receiving suggestions from other department managers, and for the first time I was appointed as a team leader from the beginning to the end of the project. Before the presentation I practiced many times and prepared for the expected questions. It was the first time to work as a team leader, but I always thought that I was responsible for my work, so I continued to work hard as usual.'],
		img: faPython,
		date: '2017 Jan - 2017 May',
		color: 'python',
		vc: 'Git',
		test: '',
		team: '2',
		phase: 'All phases'
	},
	{
		chips: [ 'C#', 'XML', '.NET' ],
		title: 'Ministry of Internal Affairs and Communications cloud-based EHR advanced business related work',
		area: '東京',
		detail: ['System for displaying medical chart data on the Web using .NET, which is authenticated by RFID, DB table rework. Participated in a large project for the first time.', 'Thanks to the fact that my senior explained well, I was able to grasp the whole picture without difficulty and was able to participate in the development of new and wonderful services.'],
		img: faHashtag,
		date: '2017 Jan - 2017 May',
		color: 'cSharp',
		vc: 'TFS',
		test: 'Microsoft Test Manager',
		team: '15',
		phase: 'Implementation'
	},
	{
		chips: [ 'C#', 'XML', '.NET' ],
		title: 'Development of waiting number system in hospital',
		area: 'Tokyo',
		detail: ['A system that increments the number by 1 each time a ticket is issued and resets the number the next day.', 'For the first time, I was alone and in charge of the project but I was able to answer my questions by my own research.'],
		img: faHashtag,
		date: '2016 Sep - 2016 Oct',
		color: 'cSharp',
		vc: 'TFS',
		test: 'Microsoft Test Manager',
		team: '1',
		phase: 'Design, Implementation, Ongoing support'
	},
	{
		chips: [ 'C#', 'Visual Basic', 'MS SQL Server', '.NET' ],
		title: 'Electronic medical record system development (in-house development)',
		area: 'Tokyo',
		detail: ['New function development of drug system master, rewriting existing drug system master from VB to C#.', 'While figuring out the unclear points from my seniors, I learned practically how to write code by looking at existing code.', 'I learned that it is faster to ask courageously and ask someone if I have any questions that I do not understand even after research.'],
		img: faHashtag,
		date: '2016 - 201 8',
		color: 'cSharp',
		vc: 'TFS',
		test: 'Microsoft Test Manager',
		team: '6',
		phase: 'Implementation'
	},
	{
		chips: [ 'C#', 'Java', 'Apache' ],
		title: 'API development for natural language processing(training) ',
		area: 'Tokyo',
		detail: ['BOW analysis API written in Java is displayed from Swagger in JSON format in .Net (Web server startup and operation with Apache).', ' Starting the server and installing Mecab for the first time was very difficult at the time, but I was excited to work on it.', 'I learned "writing code with the least amount of calculation" and "importance of understanding the mechanism by understanding the details".'],
		img: faHashtag,
		date: '2016 Jul - 2016 Aug',
		color: 'cSharp',
		vc: '',
		test: '',
		team: '1',
		phase: 'All phases'
	}
];

const color = {
	react: {
		backgroundColor: '#61dbfb',
		color: '#fff'
	},
	cSharp: {
		backgroundColor: '#9a4993',
		color: '#fff'
	},
	aws: {
		backgroundColor: '#000',
		color: '#fff'
	},
	python: {
		backgroundColor: '#6281b6',
		color: '#fff'
	},
	js: {
		backgroundColor: '#f0db4f',
		color: '#fff'
	}
};

const pjtIconsStyle = {
	display: 'block',
	width: '24px',
	height: '24px',
	position: 'relative',
	left: '50%',
	top: '50%',
	marginLeft: '-12px',
	marginTop: '-12px'
};
const sectionTitle = { en: 'Projects', ja: 'プロジェクト' };
const Projects = ({ language }) => {
	const [ projects, setProjects ] = useState([]);
	useEffect(
		() => {
			language === 'English' ? setProjects(projectsEn) : setProjects(projectsJa);
		},
		[ language ]
	);
	return (
		<div>
			<h2 className="text-center sectionTitle" style={{paddingTop:'5rem'}}>{language == 'English' ? sectionTitle.en : sectionTitle.ja}</h2>
			<VerticalTimeline layout={'1-column'}>
				{projects.map((project, j) => (
					<VerticalTimelineElement
						className={`vertical-timeline-element--work`}
						date={project.date}
						icon={<FontAwesomeIcon icon={project.img} style={pjtIconsStyle} />}
						iconStyle={color[project.color]}
						contentArrowStyle={{ borderRight: `7px solid  ${color[project.color]['backgroundColor']}` }}
						contentStyle={{ borderTop: `3px solid ${color[project.color]['backgroundColor']}` }}
						key={j}
					>
						<div className="pb-2">
							{project.chips.map((chip, i) => (
								<Chip
									size="small"
									label={chip}
									className="m-1"
									style={{ fontSize: 'medium' }}
									key={i}
								/>
							))}
						</div>
						<div className="px-3">
							<h3 className="border-0 px-0 my-0 py-1">{project.title}</h3>
							<small>{project.area}</small>
							<p></p>
							{project.detail.map((detail, i) =><p key={i} style={{width:'80%', fontSize:'1.3rem'}} className="mt-0">{detail}</p>)}
							<br />
							{project.vc ? <><span>{language==='English' ? 'Version Control: ': 'バージョン管理: '}{project.vc}</span><br /></> : null}
							{project.test ? <><span>{language==='English' ? 'Test: ': 'テスト: '}{project.test}</span><br /></> : null}
							<span>{language==='English' ? `Team: ${project.team} people`: `チーム: ${project.team}人`}</span>
							<br />
							<span>{language==='English' ? 'Project phases: ': '開発工程: '}{project.phase}</span>
						</div>
					</VerticalTimelineElement>
				))}
			</VerticalTimeline>
		</div>
	);
};

export default Projects;
